/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

const SvgIconBotWidget = props => {
  return (
    <svg viewBox="0 0 103 85" {...props} role="img" aria-hidden="true" focusable="false">
      <defs>
        <filter
          x="-8.6%"
          y="-5.2%"
          width="117.2%"
          height="120.8%"
          filterUnits="objectBoundingBox"
          id="bot-widget_svg__b"
        >
          <feOffset dy={4} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter1" />
        </filter>
        <filter
          x="-23.5%"
          y="-13.8%"
          width="147.1%"
          height="155.2%"
          filterUnits="objectBoundingBox"
          id="bot-widget_svg__e"
        >
          <feOffset dy={4} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.261063156 0" in="shadowBlurOuter1" />
        </filter>
        <path
          d="M54.5 0C75.763 0 93 17.237 93 38.5S75.763 77 54.5 77 16 59.763 16 38.5c0-4.59.803-8.991 2.276-13.073-.419.025-.84.038-1.277.038C8.839 25.465 0 20.826 0 13.234 0 9.88 1.877 6.839 4.912 4.63c6.654-4.841 17.522-4.841 24.176 0 1.099.8 2.046 1.709 2.808 2.702A38.31 38.31 0 0154.5 0z"
          id="bot-widget_svg__a"
        />
        <path
          d="M0 13.234C0 9.88 1.878 6.839 4.912 4.63c6.654-4.841 17.522-4.841 24.176 0C32.123 6.839 34 9.88 34 13.234c0 7.592-8.84 12.231-16.999 12.231-.914 0-1.765-.056-2.67-.147L4.6 30l2.093-7.023C2.747 20.598 0 17.517 0 13.234"
          id="bot-widget_svg__d"
        />
      </defs>
      <g transform="translate(4 1)" fill="none" fillRule="evenodd">
        <mask id="bot-widget_svg__c" fill="#fff">
          <use xlinkHref="#bot-widget_svg__a" />
        </mask>
        <g fill="#000">
          <use filter="url(#bot-widget_svg__b)" xlinkHref="#bot-widget_svg__a" />
          <use xlinkHref="#bot-widget_svg__a" />
        </g>
        <g mask="url(#bot-widget_svg__c)">
          <g transform="translate(53.87 1)">
            <path
              d="M2.487 13.644l.06-.092.888-1.146C6.405 8.603 8.474 6.284 9.7 5.403a.735.735 0 11.857 1.194l-.22.169c-1.084.873-2.927 2.956-5.485 6.214l-.929 1.193 1.1 4.695a.735.735 0 01-.444.85l-.104.033a.735.735 0 01-.85-.444l-.033-.104-1.179-5.035a.735.735 0 01.073-.524z"
              fill="#FFF"
              fillRule="nonzero"
            />
            <circle fill="#FFF" cx={10.35} cy={5.88} r={5.88} />
            <circle fill="#EF6461" cx={10.35} cy={5.88} r={2.94} />
          </g>
        </g>
        <path
          d="M54.665 20.11h4.41c15.831 0 28.665 12.834 28.665 28.665V68.62a8.82 8.82 0 01-8.82 8.82h-44.1A8.82 8.82 0 0126 68.62V48.775C26 32.944 38.834 20.11 54.665 20.11z"
          fill="#EF6461"
          mask="url(#bot-widget_svg__c)"
        />
        <path
          d="M57.605 20.11c-15.831 0-28.665 12.834-28.665 28.665V68.62a8.82 8.82 0 008.82 8.82h-2.94A8.82 8.82 0 0126 68.62V48.775C26 32.944 38.834 20.11 54.665 20.11z"
          fill="#FFF"
          mask="url(#bot-widget_svg__c)"
        />
        <circle
          stroke="#FFF"
          strokeWidth={1.47}
          fill="#FFF"
          mask="url(#bot-widget_svg__c)"
          cx={59.81}
          cy={53.92}
          r={13.965}
        />
        <path
          d="M59.161 28.93c4.482 0 8.81 1.062 12.683 3.064a2.205 2.205 0 01-2.025 3.918 23.145 23.145 0 00-10.658-2.572c-3.929 0-7.706.967-11.052 2.78a2.205 2.205 0 01-2.102-3.877 27.537 27.537 0 0113.154-3.313z"
          fill="#000"
          fillRule="nonzero"
          mask="url(#bot-widget_svg__c)"
        />
        <path
          d="M59.81 46.57a7.33 7.33 0 012.733.525 2.94 2.94 0 104.092 4.092 7.35 7.35 0 11-6.825-4.617z"
          fill="#000"
          mask="url(#bot-widget_svg__c)"
        />
        <g transform="matrix(-1 0 0 1 34 0)">
          <use fill="#000" filter="url(#bot-widget_svg__e)" xlinkHref="#bot-widget_svg__d" />
          <use fill="#FFF" xlinkHref="#bot-widget_svg__d" />
        </g>
      </g>
    </svg>
  );
};

export default SvgIconBotWidget;
